<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-material-card
          v-if="!loading"
          color="primary"
          icon="mdi-bank"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Restart Management - Restarts occur at 6am EST (only applies to Paythings Safes)
            </div>
          </template>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
          </v-col>
          <v-row>
            <v-col
              sm="12"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-dialog v-model="dialog">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.idnum"
                                label="Site Name"
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.address"
                                label="Address"
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-switch
                                v-model="editedItem.nightlyrestart"
                                label="Nightly Restart"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-spacer />
                </v-toolbar>

                <v-data-table
                  :headers="headers"
                  :search="search"
                  :items="currentmachines"
                  item-key="idnum"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td class="text-left">
                      {{ props.item.idnum }}
                    </td>
                    <td class="text-left">
                      {{ props.item.group }}
                    </td>
                    <td class="text-left">
                      {{ props.item.address }}, {{ props.item.city }} {{ props.item.zipcode }}
                    </td>
                    <td class="text-left">
                      {{ props.item.sitecontactnumber }}
                    </td>
                    <td class="text-left">
                      {{ props.item.sitecontactname }}
                    </td>
                    <td class="text-left">
                      {{ props.item.wifipw }}
                    </td>
                    <td class="text-left">
                      {{ props.item.wifiaccess }}
                    </td>
                    <td class="text-left">
                      {{ props.item.timezone }}
                    </td>
                    <td class="text-left">
                      {{ props.item.time_open }} Hrs
                    </td>
                    <td class="text-left">
                      {{ props.item.time_close }} Hrs
                    </td>
                    <td class="text-left">
                      {{ props.item.time_eod }} Hrs
                    </td>
                  </template>
                  <template
                    v-slot:[`item.nightlyrestart`]="{ item }"
                  >
                    {{ item.nightlyrestart }}
                  </template>
                  <template
                    v-if="userallowed"
                    v-slot:[`item.action`]="{ item }"
                  >
                    <v-icon

                      color="primary"
                      size="20"
                      @click="editItem(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary">
                      Reset
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </base-material-card>

        <v-spacer />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Components

  export default {
    data: () => ({
      search: '',
      dialog: false,
      time: null,
      newgroup: '',
      snackbar: false,
      singleExpand: true,
      timeout: 5000,
      alertmessage: '',
      currentgroups: '',
      showchange: false,
      singleSelect: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      modal2: false,
      loading: false,
      headers: [
        { text: 'Site Name', value: 'idnum', align: 'left', width: 150 },
        { text: 'Address', value: 'address', align: 'left', width: 150 },
        { text: 'Restart', value: 'nightlyrestart', align: 'center' },
        { text: 'Time Zone', value: 'timezone', align: 'center' },
        { text: 'EOD', value: 'time_eod', align: 'center' },
        { text: 'Actions', value: 'action', align: 'center', sortable: false }
      ],
      sites: [],
      editedIndex: -1,
      editedItem: {
        idnum: '',
        crypto_idnum: '',
        originalidnum: '',
        nightlyrestart: '',
        sitekey: '',
        sitetype: '',
        schedule: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        group: '',
        changeSystemID: '',
        changeProvider: '',
        allowedusers: null,
        changeorderprofiles: [],
        locationTags: null,
        safeType: 'none',
        noteCapacity: '',
        provCredit: false,
        creditprovider: '',
        creditproviderId: '',
        creditproviderLocationID: '',
        creditproviderapikey: '',
        wifipw: '',
        externalsafe: false,
        wifiaccess: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '',
        time_close: '',
        time_eod: '',
        time_deposit_summary: ''
      },
      defaultItem: {
        idnum: '',
        crypto_idnum: '',
        originalidnum: '',
        nightlyrestart: '',
        address: '',
        sitekey: '',
        sitetype: '',

        schedule: '',
        city: '',
        state: '',
        zipcode: '',
        externalsafe: false,
        wifipw: '',
        wifiaccess: '',
        group: '',
        changeSystemID: '',
        changeProvider: '',
        allowedusers: [],
        changeorderprofiles: [],
        locationTags: [],
        safeType: '',
        noteCapacity: '',
        provCredit: false,
        creditprovider: '',
        creditproviderId: '',
        creditproviderLocationID: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '',
        time_close: '',
        time_eod: '',
        time_deposit_summary: ''
      }
    }),

    computed: {
      formIsValid () {
        return this.editedItem.idnum !== '' &&
          this.editedItem.address !== '' &&
          this.editedItem.city !== '' &&
          this.editedItem.state !== '' &&
          this.editedItem.zipcode !== '' &&
          this.editedItem.group !== '' &&
          this.editedItem.sitecontactnumber !== '' &&
          this.editedItem.sitecontactname !== '' &&
          this.editedItem.supportemail !== '' &&
          this.editedItem.supportnumber !== '' &&
          this.editedItem.timezone !== '' &&
          this.editedItem.time_open !== '' &&
          this.editedItem.time_close !== '' &&
          this.editedItem.time_eod !== ''
      },
      getcurrentgroups () {
        this.$log.debug('groups', this.$store.getters.usergroups)
        this.currentgroups = this.$store.getters.usergroups
        return this.currentgroups
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },

      userallowed () {
        if (parseInt(this.$store.getters.user.level) >= 500 || this.$store.getters.user.status === 'corporate') {
          this.$log.debug('user allowed', this.$store.getters.user.level)

          return true
        }
        this.$log.debug('user NOT allowed', this.$store.getters.user.level)

        return false
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Site' : 'Set Nightly Restart'
      },
      currentmachines () {
        this.sites = this.$store.getters.loadedSites
        return this.sites
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadUserProfiles')
      this.$store.dispatch('loadChangeProfile')

      this.$log.debug('SITES LOADED: ', this.$store.getters.loadedSites)
      this.sites = this.$store.getters.loadedSites
      this.tokens = this.$store.getters.loadedTokens
      this.$log.debug('this sites is: ', this.sites)
      console.log(this.sites)
    },

    methods: {
      userlist (group) {
        this.$log.debug('%%%%% group passed is ', group)
        let people = this.$store.getters.userprofiles
        this.$log.debug('people rec is ', people)
        let usersfromgroup = people.filter(person => person.group === group)
        return usersfromgroup.map(usr => usr.email)
      },
      addgroup () {
        this.$log.debug('want to add group ', this.newgroup)
        if (this.newgroup) {
          // this.currentgroups.push(this.newgroup)
          this.$log.debug('I am adding group ', this.newgroup)
          this.$store.dispatch('createUserGroup', this.newgroup)
          // make sure to load on a good add to the db
          this.$store.dispatch('loadUserGroups')
          this.newgroup = ''
        }
      },
      removeGroup (index) {
        let numelements = 1
        let grp = this.currentgroups[index]
        this.currentgroups.splice(index, numelements)
        this.$store.dispatch('removeUserGroup', grp)
        this.$store.dispatch('loadUserGroups')
      },
      editItem (item) {
        this.editedIndex = this.sites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.$log.debug('this is an edit')
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.$log.debug(' can we save this ? ', this.editedItem.idnum)
        this.editedItem.idnum = this.editedItem.idnum.trim()
        this.editedItem.idnum = this.editedItem.idnum.replace(/\t/g, '')

        if (!this.editedItem.nightlyrestart) {
          this.editedItem.nightlyrestart = false
        }
        const restartData = {
          nightlyrestart: this.editedItem.nightlyrestart,
          sitekey: this.editedItem.sitekey,
        }
        this.$log.debug('checking ', this.editedItem.originalidnum, ' to ', this.editedItem.idnum)

        if (this.editedIndex > -1) {
          this.$log.debug('we saved on edit here')
          this.$log.debug('passing SITE KEY ', restartData.sitekey)
          if (this.editedItem.idnum !== this.editedItem.originalidnum) {
            // clone the profile to the new name
            this.$log.debug('cloning ', this.editedItem.originalidnum, ' to ', this.editedItem.idnum)
          }
          this.$store.dispatch('updateNightlyRestart', restartData)
          console.log('nightly restart set ', this.editedItem.nightlyrestart)
          Object.assign(this.sites[this.editedIndex], this.editedItem)
        }
        this.$store.dispatch('loadunits')
        this.$store.dispatch('loadsiteProfiles')
        this.$store.dispatch('loadSiteConfigs')
        this.$store.dispatch('loadUserProfiles')
        this.sites = this.$store.getters.loadedSites
        this.close()
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>
